import React, { useState } from "react";
import { generateNumbers } from "../utils";

const TimePickerField = ({ onChange, field, label, maxTime, ...rest }) => {
   let [data, setData] = useState({});
   let maxHour = maxTime ? parseInt(maxTime.split(":")[0]) : 23;
   let hours = generateNumbers(0, maxHour);
   let minutes = generateNumbers(0, 59, 15);
   let fmtNum = (n) => `${n < 10 ? "0" + n : n}`;
   const handleClick = (ev) => {
      ev.stopPropagation();
   };
   function handleSelect(ev) {
      let { name, value } = ev.target;
      console.log({ name, value });
      let values = { ...data, minute: "00", [name]: value };
      console.log("Values: ", values);
      setData(values);
      if (Object.entries(values).length === 2)
         onChange && onChange({ name: field, value: `${values.hour}:${values.minute}` });
   }
   document.querySelectorAll(".timepicker-field select").forEach((s) => {
      let valid = s.checkValidity();
      s.setCustomValidity(!s.value && !valid ? "Select time" : "");
      s.reportValidity();
   });
   return (
      <div className='timepicker-field' onClick={handleClick}>
         <label>{label}</label>
         <div className='select-wrap'>
            <select name='hour' onChange={handleSelect} {...rest}>
               <option value=''>HH</option>
               {hours.map((h, idx) => (
                  <option key={idx}>{fmtNum(h)}</option>
               ))}
            </select>
            <span>:</span>
            <select name='minute' onChange={handleSelect} {...rest}>
               {minutes.map((m, idx) => (
                  <option key={idx}>{fmtNum(m)}</option>
               ))}
            </select>
         </div>
      </div>
   );
};

export default TimePickerField;
